var render = function (_h,_vm) {var _c=_vm._c;return _c('button',_vm._g(_vm._b({staticClass:"mn-btn",class:[_vm.data.class, _vm.data.staticClass, _vm.props.variation]},'button',_vm.data.attrs,false),_vm.listeners),[_vm._t("default",[_vm._v("Button")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }